// extracted by mini-css-extract-plugin
module.exports = {"introTitle":"Intro_introTitle__sOzj2","descriptionContainer":"Intro_descriptionContainer__2mNxx","avatarSection":"Intro_avatarSection__3CcpJ"};